import './page/acris-faq-group-list';
import './page/acris-faq-group-detail';
import './page/acris-faq-group-create';
import './component/acris-one-to-many-faq-grid';

const { Module } = Shopware;

Module.register('acris-faq-group', {
    type: 'plugin',
    name: 'AcrisFaq',
    title: 'acris-faq-group.general.mainMenuItemGeneral',
    description: 'acris-faq-group.general.description',
    color: '#a6c836',
    icon: 'regular-bars-circle',
    favicon: 'icon-module-settings.png',

    routes: {
        index: {
            component: 'acris-faq-group-list',
            path: 'index',
            meta: {
                parentPath: 'acris.faq.list.index'
            }
        },
        detail: {
            component: 'acris-faq-group-detail',
            path: 'detail/:id',
            meta: {
                parentPath: 'acris.faq.group.index'
            }
        },
        create: {
            component: 'acris-faq-group-create',
            path: 'create',
            meta: {
                parentPath: 'acris.faq.group.index'
            }
        }
    }
});
